<template>
  <!--忘记密码-->
  <div id="pwdforget">
    <header>
      <div class="logo"></div>
    </header>
    <nav class="title">
      <a>忘记密码</a>
    </nav>
    <ul class="main">
      <li class="tel">
        <input type="text" placeholder="请输入您的手机号" required="" maxlength="11" pattern="^(1[3-9]d{9})$" v-model.number="phone">
        <a class="getverify" v-on:click="getPhoneCode()">获取验证码</a>
      </li>
      <li class="verify">
        <input type="text" placeholder="请输入验证码" required="" maxlength="6" v-model.trim="code">
      </li>
      <li class="newpwd">
        <input type="password" name="password" placeholder="新密码不能与旧密码相同" v-model="password">
      </li>
      <li>
        <input type="submit" value="确定" v-on:click="getAlterPassword()">
      </li>
    </ul>
  </div>
</template>

<script>
import axios from 'axios'
import {encryption} from '../../assets/js/encryption.js' // 请求必需携带公共头部
export default {
  name: 'PwdForget',
  data () {
    return {
      phone: '', // 登录手机号码
      code: '', // 登录验证码
      password: '',
      backTo: this.$route.query.backto ? this.$route.query.backto : ''
    }
  },
  methods: {
    getPhoneCode () {
      let data = {
        phone: this.phone,
        type: 3 // 请求类型 注册(1)、登录(2)、找回密码(3)、更换手机号原手机(4)、新手机(5)、微信绑定手机号(6)
      }
      if (!data.phone) {
        alert('手机号不能为空')
        return false
      }
      axios({
        method: 'GET',
        url: '/api/app/v1/get_phone_code',
        params: data,
        headers: {
          'sign': encryption(data)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            alert('短信验证码已发送，请留意查收！')
          } else alert(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    getAlterPassword () {
      let data = {
        phone: this.phone,
        code: this.code,
        password: this.password
      }
      if (!data.phone) {
        alert('手机号不能为空')
        return false
      }
      if (!data.code) {
        alert('密码不能为空')
        return false
      }
      if (!data.password) {
        alert('设置密码不能为空')
        return false
      }
      axios({
        method: 'POST',
        url: '/api/app/v1/post_retrieve_password_code',
        params: data,
        headers: {
          'sign': encryption(data)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 20002 || res.data.errcode === 200) {
            this.$store.dispatch('alterName', res.data.data.name)
            this.$store.dispatch('alterNickname', res.data.data.nickname)
            this.$store.dispatch('alterPeriod', res.data.data.period)
            this.$store.dispatch('alterPortrait', res.data.data.portrait)
            this.$store.dispatch('alterSchool', res.data.data.school_name)
            this.$store.dispatch('alterSubject', res.data.data.subject)
            this.$store.dispatch('alterToken', res.data.data.token)
            this.$store.dispatch('alterUid', res.data.data.uid)
            this.$store.dispatch('alterVipname', res.data.data.vip_name)
            this.$store.dispatch('alterViptime', res.data.data.vip_time)
            console.log(this.$store.state.name)
            console.log(this.$store.state.nickname)
            console.log(this.$store.state.period)
            console.log(this.$store.state.portrait)
            console.log(this.$store.state.school)
            console.log(this.$store.state.subject)
            console.log(this.$store.state.token)
            console.log(this.$store.state.uid)
            console.log(this.$store.state.vipname)
            console.log(this.$store.state.viptime)
            alert('密码修改成功，已登录')
            if (this.backTo) {
              this.$router.push({name: this.backTo})
            } else {
              this.back()
            }
          } else alert(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    back () {
      if (window.history.length <= 1) {
        this.router.push({path: '/'})
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style scoped lang="stylus">
#pwdforget
  header
    position: relative
    width: 7.5rem
    height: 3.58rem
    background: url(../../assets/img/pwdforget_bg_head.png) no-repeat center top
    -webkit-background-size: 7.5rem 2.98rem
    background-size: 7.5rem 2.98rem
    .logo
      position: absolute
      bottom: 0
      left: 50%
      width: 1.2rem
      height: 1.2rem
      background: url(../../assets/icon/pwdforget_icon_logo.png) no-repeat center #fff
      -webkit-background-size: 1.12rem
      background-size: 1.12rem
      -webkit-border-radius: 50%
      -moz-border-radius: 50%
      border-radius: 50%
      -webkit-transform: translate(-50%, 0)
      -moz-transform: translate(-50%, 0)
      -ms-transform: translate(-50%, 0)
      -o-transform: translate(-50%, 0)
      transform: translate(-50%, 0)
      box-shadow:0rem 0.04rem 0.08rem 0rem rgba(172,229,255,0.3)
  nav.title
    display: flex
    justify-content: center
    align-items: center
    width: 7.5rem
    height: .56rem
    margin: .38rem 0
    text-align: center
    a
      line-height: .56rem
      font-size: .4rem
      color: #050505
      font-weight: 600
  ul.main
    width: 7.5rem
    padding: 0 .4rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    li
      position: relative
      width: 6.7rem
      height: 1rem
      line-height: 1rem
      background: url(../../assets/icon/pwdforget_icon_phone.png) no-repeat center left
      -webkit-background-size: .4rem
      background-size: .4rem
      border-bottom: .04rem solid #F3F3F3
      padding: 0 0 0 .6rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      &:last-child
        background: none
        border: none
        padding: 0
      &:nth-of-type(2)
        background-image: url(../../assets/icon/pwdforget_icon_shield.png)
      &:nth-of-type(3)
        background-image: url(../../assets/icon/pwdforget_icon_lock.png)
      input[type=text]
        font-size: .28rem
      input[type=submit]
        width: 6.7rem
        height: .8rem
        background-color: #1E81F2
        margin-top: .6rem
        font-size: .32rem
        color: #fff
        text-align: center
        -webkit-border-radius: .4rem
        -moz-border-radius: .4rem
        border-radius: .4rem
      a.getverify
        position: absolute
        top: .2rem
        right: 0
        display: block
        width: 1.4rem
        height: .52rem
        line-height: .52rem
        border: .02rem solid #FF6100
        font-size: .24rem
        color: #FF6100
        text-align: center
        -webkit-border-radius: .26rem
        -moz-border-radius: .26rem
        border-radius: .26rem
  ::-webkit-input-placeholder
    color: #D8D8D8
</style>



// WEBPACK FOOTER //
// src/components/login/PwdForget.vue